import gql from "graphql-tag";

export const PUSH_ABSENT_MEETING = gql`
  mutation ($input: meetingAbsentInput) {
    pushAbsentMeeting(input: $input)
  }
`;
